async function writeClipboardText(text: string | undefined | null) {
	try {
		if (text) await navigator.clipboard.writeText(text);
	} catch (error) {
		console.error((error as Error).message);
	}
}

export { writeClipboardText };
